import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const StrategicShare = ({ reportTitle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <>
      <button 
        onClick={() => setIsModalOpen(true)}
        className="p-2 rounded-lg bg-white dark:bg-slate-700 shadow-sm text-slate-400 hover:text-brand-cyan transition-colors"
        title="Share Report"
      >
        <SafeIcon name="Share2" className="w-4 h-4" />
      </button>

      <AnimatePresence>
        {isModalOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center px-6">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute inset-0 bg-brand-dark/80 backdrop-blur-sm"
              onClick={() => setIsModalOpen(false)}
            />
            <motion.div 
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-3xl p-8 md:p-12 shadow-2xl border border-white/10"
            >
              <button 
                onClick={() => setIsModalOpen(false)}
                className="absolute top-6 right-6 text-slate-400 hover:text-white transition-colors"
              >
                <SafeIcon name="X" className="w-6 h-6" />
              </button>

              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-brand-cyan/20 text-brand-cyan rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon name="Send" className="w-8 h-8" />
                </div>
                <h3 className="text-2xl font-heading font-bold dark:text-white text-slate-900 mb-2">Share Strategic Insight</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm font-medium">Exporting: {reportTitle}</p>
              </div>

              <div className="space-y-6">
                <div>
                  <label className="block text-[10px] uppercase tracking-widest text-slate-500 dark:text-slate-400 font-bold mb-3">Secure Shareable Link</label>
                  <div className="flex gap-2">
                    <input 
                      readOnly 
                      value={`https://portal.julie-adams.com/share/rpt_${Math.random().toString(36).substr(2, 9)}`}
                      className="flex-grow bg-slate-50 dark:bg-brand-dark border border-slate-200 dark:border-slate-800 px-4 py-3 rounded-xl text-xs font-mono text-slate-600 dark:text-slate-300 outline-none"
                    />
                    <button 
                      onClick={handleCopy}
                      className="px-6 py-3 bg-brand-cyan text-brand-dark font-black text-xs uppercase tracking-widest rounded-xl hover:bg-white transition-colors"
                    >
                      {isCopied ? 'Copied' : 'Copy'}
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <button className="flex items-center justify-center gap-2 p-4 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                    <SafeIcon name="Mail" className="w-4 h-4 text-brand-red" />
                    <span className="text-xs font-bold dark:text-white">Email PDF</span>
                  </button>
                  <button className="flex items-center justify-center gap-2 p-4 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                    <SafeIcon name="Slack" className="w-4 h-4 text-brand-cyan" />
                    <span className="text-xs font-bold dark:text-white">Post to Slack</span>
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default StrategicShare;